/**
 * Apps Script over the FAL election sheet; OB 1 Click choices land on their own
 * tab. Prod is the Fondos deployment; every other build hits a copy of the sheet.
 */
export const FAL_ELECTION_URL =
  import.meta.env.VITE_ENVIRONMENT === "prod"
    ? "https://script.google.com/macros/s/AKfycbxZiTbTaX1_CT4heO8hfSZxS0PYV45GU-LMhEUVCewWi78VBJPBj91GFRZRt0sstScO_g/exec"
    : "https://script.google.com/macros/s/AKfycbytCIpnoNgk0a9Lna9MqQxVWKP1caIqXQGOqtwoupie0VN5UUgmFdtuJDzh9B6QtDLxWQ/exec";

export interface FalFundAllocation {
  pct: number;
  activo: string;
}

/** As in the script's Config.gs: `id` is what it expects back, `nombre` what lands in the sheet. */
export interface FalFund {
  id: string;
  nombre: string;
  descripcion: string;
  urlReglamento: string;
  composicion: FalFundAllocation[];
  tna: string;
  duration: string;
}

export interface FalFundsInfo {
  fechaCifras: string;
  fondos: FalFund[];
}

export type FalElectionErrorCode =
  | "DATOS_INVALIDOS"
  | "FONDO_INVALIDO"
  | "YA_ELEGIDO"
  | "NO_REGISTRADO"
  | "LIMITE"
  | "ACCION_INVALIDA"
  | "ERROR";

export interface FalElectionError {
  ok: false;
  codigo: FalElectionErrorCode;
  mensaje: string;
  falElegido?: string;
  fechaAceptado?: string;
}

// Config.gs carries its own palette; the landing follows Figma's.
const colorByAsset: Record<string, string> = {
  cer: "#7CB4D9",
  "plazo fijo": "#3498DA",
  "dual dl/tamar": "#3498DA",
  "dolar linked": "#425759",
  tamar: "#3463D9",
};
const fallbackColors = ["#7CB4D9", "#3498DA", "#425759", "#3463D9"];

export const getAssetColor = (asset: string, index: number) =>
  colorByAsset[asset.normalize("NFD").replace(/\p{M}/gu, "").toLowerCase()] ??
  fallbackColors[index % fallbackColors.length];

export const mockFalFunds: FalFundsInfo = {
  fechaCifras: "06/10/2026",
  fondos: [
    {
      id: "disponibilidad",
      nombre: "Allaria Disponibilidad FCIA FAL",
      descripcion:
        "Estructura orientada a empleadores cuya nómina presenta mayor frecuencia de extinciones laborales, donde la disponibilidad de los recursos en plazos cortos es el criterio principal de estructuración.",
      urlReglamento:
        "https://drive.google.com/file/d/1eoADhhRSq_zmtFO4OcC-KUpTvwe_lHMc/view?usp=sharing",
      composicion: [
        { pct: 70, activo: "CER" },
        { pct: 10, activo: "Plazo Fijo" },
        { pct: 10, activo: "Dólar Linked" },
        { pct: 10, activo: "TAMAR" },
      ],
      tna: "26,65%",
      duration: "0,12",
    },
    {
      id: "acumulacion",
      nombre: "Allaria Acumulación FCIA FAL",
      descripcion:
        "Estructura orientada a empleadores cuya nómina presenta menor frecuencia de extinciones laborales, lo que habilita una mayor duration y una tasa real superior.",
      urlReglamento:
        "https://drive.google.com/file/d/1HB0rFxnQdC3oz3u4CNSroorjhrdlT0SG/view?usp=sharing",
      composicion: [
        { pct: 75, activo: "CER" },
        { pct: 10, activo: "Dual DL/TAMAR" },
        { pct: 15, activo: "TAMAR" },
      ],
      tna: "29,10%",
      duration: "0,77",
    },
  ],
};
